/* eslint-disable */

function DataManager(index, isXfinity = false) {
    /** CONSTANTS **/

    const BODY_TITLE = [
        {
            element: 'p',
            className: 'bodyLeftColumnSmallTitle',
            text: isXfinity ? 'More Protection. More Savings.' : 'Smart Coverage for Homeowners'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnBigTitle',
            text: isXfinity
                ? 'The Benefits of Smart Home Coverage'
                : "Don't Buy Homeowner's Insurance Without Reading This First"
        }
    ];

    const BODY_LEFT_COLUMN_INTRO = [
        { element: 'img', className: 'bodyLeftColumnPicture', attr: { src: 'taboola/resources/post_main_img@2x.jpg' } },
        {
            element: 'p',
            className: 'bodyLeftColumnP',
            text: isXfinity
                ? 'A startling statistic: More than 60% of homes in the United States are underinsured. But don’t sweat it, Xfinity customers now have access to smarter home insurance through Hippo Insurance to avoid these common pitfalls. We’ve teamed up with Xfinity to help give their customers the most updated, modern coverage for their homes - plus, all new customers receive a smart home starter kit, with multi-purpose sensors to help avoid water and fire damage or break-ins.'
                : 'A startling statistic: About 60% of homes in the United States are underinsured. That means six of your closest neighbors don’t have enough home insurance. Or it means five of your neighbors are not completely covered…and you are the sixth. Your home may be where your heart is, but it is also one of your biggest financial assets and you want to keep it protected. Yet more startling than the underinsured statistic is that most insurance policies have really out-of-date standard coverage. So yes to stamp collections and fur coats but no to computers and electronics.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnP',
            text: isXfinity
                ? "<a href='https://myhippo.com/xfinity?utm_campaign=home-insurance-guide' target='_blank'>Hippo Insurance </a> offers safety, savings and speed, the trifecta. Plus, their policies are underwritten by the largest insurance partners on the planet, making your policy relevant and secure. Here are the three reasons why <a href='https://myhippo.com/xfinity?utm_campaign=home-insurance-guide' target='_blank'>customers</a> are switching to Hippo in droves."
                : "<a href='https://myhippo.com' target='_blank'>Hippo Insurance</a> changes that with modern home insurance coverage. They offer safety, savings and speed, the trifecta. Plus, their policies are underwritten by the largest insurance partners on the planet, making your policy relevant AND secure. Here’s the three reasons why <a href='https://myhippo.com/reviews.html' target='_blank'>customers</a> are switching to Hippo in droves."
        }
    ];

    const BODY_LEFT_COLUMN_BODY = [
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '1. Safety' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'The first reason to switch to modern home insurance coverage: Safe and secure coverage of the structures and possessions part of your home in today’s world. Hippo takes it one step further and covers those things that could cause some of the biggest headaches, such as:'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Equipment breakdown coverage – like when the A/C unit collapses after multiple days of stifling summer heat. Hippo also covers things like swimming pool pumps and solar panels.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Service line protection – the gap that traditional policies leave open for coverage of service lines from the house to the street where the municipal lines are. Most people don’t even think about this until the water main springs a leak, turning the lawn into a rice paddy.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text: 'Water backup coverage – there’s already enough to worry about with, um, septic or sewage backup.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '2. Savings' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text: `Next reason: <a href='${
                isXfinity ? 'https://myhippo.com/xfinity?utm_campaign=home-insurance-guide' : 'https://myhippo.com'
            }' target='_blank'>Hippo</a> includes modern coverage but got rid of all the inefficient processes and outdated provisions that have been part of the home insurance industry for a long time. This means lower premiums, letting customers like you save up to 25% on homeowners’ insurance.`
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'So your new laptop? It’s covered. As is the rest of your home office equipment. Since Hippo figured out a smarter way to provide home insurance for today’s households, they can offer up to four times more coverage for home electronics and office equipment.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '3. Speed' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Third reason: You might be thinking that such great coverage with such great savings is complicated to set up. Nope. Getting a quote from Hippo takes as little as 60 seconds. They thought of everything: They pre-filled information on the questionnaire that can take days to find (who knows the distance to the nearest fire hydrant? Hippo does); they got rid of the jargon and complicated language so you can actually understand and answer the questions; and, they save all your information so you can pick up where you leave off if you need to.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: 'Switching' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text: `Bonus, a fourth reason: <a href='${
                isXfinity ? 'https://myhippo.com/xfinity?utm_campaign=home-insurance-guide' : 'https://myhippo.com'
            }' target='_blank'>Hippo</a> says you can sign up for a policy in less than four minutes. Or, contact one of their licensed agents and let them manage switching your current policy. Representatives will take care of all the details, including having any prorated refund checks sent directly to you.`
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'FOUR of the right reasons to switch your home insurance coverage. <b>Switch home insurance now and save with Hippo</b>.'
        },
        { element: 'p', className: 'bodyLeftColumnBigText', text: 'Save up to 25% now' }
    ];

    const BODY_LEFT_COLUMN_LEFT_FOOTER = [
        { element: 'div', className: 'leftColumnFooterLeftColumnIcon' },
        {
            element: 'p',
            className: 'leftColumnFooterLeftColumnText',
            text:
                'If you have any questions about your policy, need help while filing out your application, or need to file a claim, please call <b>1-800-585-0705</b>'
        },
        {
            element: 'p',
            className: 'leftColumnFooterLeftColumnText',
            text:
                "For more general questions, or if you dislike talking to people, you can email us at <a href='mailto:hello@myhippo.com' target='_top'>hello@myhippo.com</a>"
        },
        {
            element: 'a',
            attr: {
                href: isXfinity
                    ? 'https://myhippo.com/xfinity-about?utm_campaign=home-insurance-guide'
                    : 'https://myhippo.com/about',
                target: '_blank'
            },
            className: 'leftColumnFooterLeftColumnLink',
            text: 'ABOUT'
        },
        {
            element: 'a',
            attr: {
                href: isXfinity
                    ? 'https://myhippo.com/xfinity-faq?utm_campaign=home-insurance-guide'
                    : 'https://myhippo.com/faq',
                target: '_blank'
            },
            className: 'leftColumnFooterLeftColumnLink',
            text: 'FAQ'
        },
        {
            element: 'a',
            attr: {
                href: isXfinity
                    ? 'https://myhippo.com/blog?utm_campaign=home-insurance-guide'
                    : 'https://myhippo.com/blog',
                target: '_blank'
            },
            className: 'leftColumnFooterLeftColumnLink',
            text: 'BLOG'
        },
        {
            element: 'p',
            className: 'leftColumnFooterLeftColumnSmallText',
            text: 'Copyright &reg; 2017-2019 Hippo Insurance &trade;.'
        }
    ];

    const BODY_LEFT_COLUMN_RIGHT_FOOTER = [
        { element: 'p', className: 'leftColumnFooterRightColumnTitle', text: 'Smart Coverage for Homeowners' },
        { element: 'p', className: 'leftColumnFooterRightColumnQuestion', text: 'Why do I need home insurance?' },
        {
            element: 'p',
            className: 'leftColumnFooterRightColumnAnswer',
            text:
                'Sadly, bad things can happen in - and to - your home. Think of home insurance as the roof over your roof. It’s there to protect you, your valuables and your largest financial asset.'
        },
        {
            element: 'p',
            className: 'leftColumnFooterRightColumnQuestion',
            text: 'What is typically included in home insurance?'
        },
        {
            element: 'p',
            className: 'leftColumnFooterRightColumnAnswer',
            text:
                'Home insurance typically covers your home, other structures on your property, specific possessions inside your home, and liability (for example, stemming from injuries that take place at your home). However not all home insurance is created equal. Hippo has taken steps to determine what types of coverage you truly need and we’ve enhanced our policies to offer best-in-class protection.'
        },
        {
            element: 'p',
            className: 'leftColumnFooterRightColumnQuestion',
            text: 'How does Hippo’s coverage compare to other home insurance?'
        },
        {
            element: 'p',
            className: 'leftColumnFooterRightColumnAnswer',
            text:
                'Hippo has made home insurance easier to secure and  with savings of up to 25% for customers. Obtain a quote in as little as 60 seconds and purchase a policy in under four minutes.<br />More than 60% of U.S. homes are underinsured, leaving consumers’ most valuable asset at risk. Hippo uses relevant data sets to evaluate each home as accurately as possible to ensure that policies comprehensively cover all the most important aspects of the property.'
        }
    ];

    let BODY_RIGHT_COLUMN = [
        { element: 'p', className: 'rightColumnBigText', text: 'Save up to 25%<br />*Get a quote in 60 seconds.' },
        { element: 'p', className: 'rightColumnText', text: 'Smart insurance coverage for your modern lifestyle' },
        { element: 'input', className: 'rightColumnFirstButton', placeholderText: 'What’s your home address?' },
        { element: 'div', className: 'rightColumnSecondButton', text: 'GET INSTANT QUOTE' },
        {
            element: 'p',
            className: 'rightColumnSmallText',
            text:
                "*Estimated premium savings based on state rate comparisons of Hippo's prices as compared to average industry prices."
        }
    ];

    const BODY_TITLE_2 = [
        { element: 'p', className: 'bodyLeftColumnSmallTitle', text: 'Smart Coverage for Homeowners' },
        {
            element: 'p',
            className: 'bodyLeftColumnBigTitle',
            text: 'Sign Up for Homeowners Insurance in Less Than Four Minutes'
        }
    ];

    const BODY_LEFT_COLUMN_INTRO_2 = [
        { element: 'img', className: 'bodyLeftColumnPicture', attr: { src: 'taboola/resources/post_main_img2@2x.jpg' } }
    ];

    const BODY_LEFT_COLUMN_BODY_2 = [
        {
            element: 'p',
            className: 'bodyLeftColumnSectionHeader',
            text: 'Get smart home insurance in the time it takes you to get a cup of coffee'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Obtaining home insurance has the reputation as a complicated and time-consuming endeavor. It usually requires collecting a long list of hard-to-find information and filling out form after form before you even get a chance to talk about what’s included as part of your coverage. Wouldn’t it be great if the whole process was simple and getting a home insurance policy as quick as, say, getting a cup of coffee? Now, <b>you can get a quote from Hippo Insurance in 60 seconds</b> and sign up for a policy in less than four minutes, about the same amount of time to get that cup of coffee.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: 'What information do I need?' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Although requirements vary from company to company, most insurers will ask you to provide information about things related to your home. Things such as: the year your home was built, square footage of each floor, exterior construction and garages, what the roof is made of, any local alarms or security systems, the type of heating, any home-based business, additional structures on the property, even the distance to the closest fire hydrant. You can collect much of this information from public sources like municipal building records or through online tools like Zillow. As part of its application process, Hippo already does this, leveraging its database to pre-fill the online questionnaire with information that will likely take you several days to collect.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'You also need to decide what kind of coverage you need. Do you need coverage in case of fire or floods? To insure any fine arts or antiques? Jewelry and stamp collections? Sewer or electrical lines? What about electronics and computers? Given today’s lifestyles and more modern possessions, your home inventory likely includes more laptops and equipment and fewer stamps, which should factor into your ideal policy and the cost to cover it. Thanks to the efficiencies it created to provide more modern and relevant policies, Hippo can pass on up to four times more coverage for home electronics than most companies.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: 'Less time, more coffee' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Assuming you complete the application process and determine the coverage and cost for your home insurance, one of the final steps is to “bind your policy,” which is another way to confirm that your coverage is in place. Keep in mind that this can usually take several days, unless you work with Hippo, which allows you to bind the policy online through the same application process you used to get a quote. Instead of three additional days in the typical sign-up process, Hippo lets you do so <b>in four minutes</b>. This is something particularly important to homebuyers who are required to show proof of insurance to the lender before they can move to the contract stage of buying a home.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Now you can save time and money on homeowners’ insurance, letting you spend it instead on a cup of coffee.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text: '<b>Get your home insurance quote now and save with Hippo</b>'
        },
        { element: 'p', className: 'bodyLeftColumnBigText', text: 'Save up to 25% now' }
    ];

    const BODY_TITLE_3 = [
        { element: 'p', className: 'bodyLeftColumnSmallTitle', text: 'Smart Coverage for Homeowners' },
        {
            element: 'p',
            className: 'bodyLeftColumnBigTitle',
            text: 'The 4 Most Important Questions to Ask When Shopping for Home Insurance'
        }
    ];

    const BODY_LEFT_COLUMN_INTRO_3 = [
        { element: 'img', className: 'bodyLeftColumnPicture', attr: { src: 'taboola/resources/post_main_img3@2x.jpg' } }
    ];

    const BODY_LEFT_COLUMN_BODY_3 = [
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: 'How to evaluate home insurance coverage' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Asking a few specific questions could turn a long research project into a snap when evaluating a home insurance policy. Just like that, tailoring a policy to fit your lifestyle – and save you money – becomes much easier when you know the answers.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '1. Do you own a $3 coin?' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'There really is such a thing. Minted in the latter 1800s, it’s made of gold and bears a representation of Lady Liberty. Something you would know if you’re into numismatics and have a coin collection worth protecting. Determining how much it’s worth is the first step in deciding how much coverage to include in your policy. Knowing the actual price of your personal valuables is just the first step to determine your coverage.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Consider the things you use daily, as you do a walk through of your house. If you find yourself in a home office, you’re likely undercovered for electronics and equipment. <a href='https://myhippo.com' target='_blank'>Hippo Insurance</a> <b>provides up to four times</b> more coverage than other providers on the electronics and equipment that run your life, from big-screen TVs to laptop computers. They also include equipment breakdown and service line protection in all their policies so your refrigerator would be covered along with your septic lines under the great lawn. Consider what’s valuable to you, and would need to be replaced immediately if you ever had to face a homeowners insurance claim."
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '2. Do you live near a fire hydrant?' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'If your home is near a fire hydrant or a fire station, your insurance rates are likely to be lower. It turns out that homes located in urban and suburban areas typically get better fire ratings than those in rural areas. Where your home is located is one of the three biggest factors insurance companies consider when determining coverage and cost. Makes sense, doesn’t it?'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'In addition to that fire hydrant, insurance companies also ask about the weather. While it may seem polite, they really want to know if your home is in a catastrophe-prone area. Think fire line, hurricanes, floods, tornadoes and the like. If your home is in an area prone to natural disasters, you want to understand what’s at stake and plan ahead to protect your assets.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '3. Do you have a dog?' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Dogs are one of the most popular pets to own in the United States, to the tune of 90 million dogs in 2017. Sometimes they also bite and people require medical treatment. This is where home insurance coverage comes in. Most policies cover dog bites unless your dog is a certain breed or has a history of biting.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'The same question applies to more exotic animals too. From pythons to leopards, chimpanzees to alligators, more exotic animals may not be insurable under your homeowners’ policy.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '4. Do you have a smart house?' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                '“Oh, if only this house could talk, the stories it would tell.” Nowadays, houses warn of fewer ghosts and use more technology and devices to keep it safe. Using a smartphone or computer, homeowners can monitor and control systems in their homes. Some of the most common devices include smoke detectors, water monitors and alarm systems.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Insurance companies, like <a href='https://myhippo.com' target='_blank'>Hippo</a>, <b>have begun to reward homeowners</b> for installing smart technology, <b>reducing premiums by up to 25%</b> or subsidizing the cost to purchase and install it. Insurers look at these devices as a way to minimize damage and lower the number of claims."
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: 'That makes everyone smart, not just the house.' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text: '<b>Ask the right questions about home insurance coverage with Hippo</b>'
        },
        { element: 'p', className: 'bodyLeftColumnBigText', text: 'Save up to 25% now' }
    ];

    const BODY_TITLE_4 = [
        { element: 'p', className: 'bodyLeftColumnSmallTitle', text: 'Smart Coverage for Homeowners' },
        {
            element: 'p',
            className: 'bodyLeftColumnBigTitle',
            text: 'Homeowners: How to Save up to 30% on Home Insurance'
        }
    ];

    const BODY_LEFT_COLUMN_INTRO_4 = [
        {
            element: 'img',
            className: 'bodyLeftColumnPicture',
            attr: { src: 'taboola/resources/post_main_img4@2x.jpg' }
        },
        {
            element: 'p',
            className: 'bodyLeftColumnP',
            text:
                "Homeowners insurance costs vary widely. Thanks to the increasing number of natural disasters happening nationwide, bigger claims and rising construction costs, <a href='https://myhippo.com/blog/rising-insurance-premiums-explained' target='_blank'>average premiums are on the rise</a>. But don’t let the perceived cost of insurance prevent you from keeping your home and your family safe. There are plenty of ways to save money without sacrificing coverage."
        },
        {
            element: 'p',
            className: 'bodyLeftColumnP',
            text:
                "Insurance companies aim to cut premium costs for nearly anything that lowers your risk profile. Check out the top 10 discounts and credits below and see if there’s a way to spend less money on your monthly premiums. <a href='https://myhippo.com' target='_blank'>Hippo</a>, a smart home insurance company, offers up to 25% savings on its policies and offers all of the discounts included below."
        }
    ];

    const BODY_LEFT_COLUMN_BODY_4 = [
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '1. Bundled policy discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Insurance companies often offer companion policies, also known as a bundled policy. Luckily, many carriers allow you to take advantage of this discount even if you don't purchase all your policies through them, which dispels a common myth that the only way to obtain a bundled discount is through a single carrier. For example, you can select the best car insurance provider for your auto policy and best home insurance provider to financially protect your property, asking both to include their bundled discounts (once they verify that you have an active policy with another carrier)."
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "All carriers that offer this discount to their clients for multiple products within their company should be able to offer you a similar discount from your selected carriers. New insurers like  <a href='https://myhippo.com' target='_blank'>Hippo</a> are able to build in discounts like companion policy into their base pricing, so the savings are already included. Do your research before committing to a single carrier due to bundling discounts, the savings may not be as drastic as you think."
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text: '<b>Potential savings</b>: As much as 15% (from bundling home and auto insurance)'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '2. Early signing discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'When it comes to homeowners insurance, it pays to be proactive. If you have a home or condo, you could save money and qualify for a discount by securing a new insurance policy before your existing one expires or you close on your new home. Most insurers, like Hippo reward customers for signing up for home insurance 8 or more days before they need their policy to start. So think of it as a bonus for crossing an item off your to-do list a week early.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: '<b>Potential savings</b>: About 10%' },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '3. New home discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Because you won’t have to worry about wear and tear with a newly constructed home, you won’t have to pay as much money to insure it. New pipes are less likely to burst, new furnaces are less likely to malfunction and new electric wires are less likely to catch fire. And homeowners with new homes are less likely to end up with costly claims.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: '<b>Potential savings</b>: As much as 30%' },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '4. Smart home discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Insurance providers <a href='https://myhippo.com/blog/insurance-providers-want-smart-home' target='_blank'>love smart home devices</a>. They increase energy efficiency and help protect homes. More importantly, they can detect issues before they happen, minimize damage and lower the number of claims policyholders file. High tech gadgets like smoke detectors, alarm systems and water leak detectors can help you score big discounts. The amount you could save will depend on the number of devices you’ve installed."
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: '<b>Potential savings</b>: Between 5% and 15%' },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '5. No-claims discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'You know those auto insurance commercials where they promise a discount for good drivers? The no-claims discount offers homeowners a similar deal. It trims premiums for policyholders who go a certain number of years (such as 10 years) without filing a claim. Why? Fewer claims means more money in your insurer’s pocket and some companies are willing to pass those savings onto their customers.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: '<b>Potential savings</b>: As much as 20%' },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '6. No-mortgage discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'You could save money by paying for your home upfront. Just like banks, insurers consider you less of a risk if you’re mortgage-free. It signals that you’re a financially responsible (and wealthy) person. You’ll also have more of an incentive to maintain and protect the property than someone who only owns a small percentage of their home.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: '<b>Potential savings</b>: As much as 10%' },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '7. Affinity group discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'If your alma mater, cable company or even employer pairs up with a home insurance company, the partnership may give you access to an affinity group discount. If you already have an insurance provider, check their list of partners to see if you’re involved with any of the participating groups. In addition to discounts, insurers sometimes provide special perks, like lifetime renewability or rates that are locked in temporarily.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: '<b>Potential savings</b>: Between 5% and 20%' },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '8. HOA discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Homeowners association (HOA) fees contribute to a master insurance policy that covers shared real estate (think: community pools and gyms). The master policy won’t insure your dwelling, but it could help you get a discount on your own policy. HOAs usually have strict rules, community standards and a neighborhood watch. That means your home is well-maintained and safer from theft or vandalism, which providers will reward with more affordable premiums.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: '<b>Potential savings</b>: Between 5% and 10%' },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '9. Fire extinguisher discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Small protective devices can also help you save money on insurance premiums. For example, just owning a fire extinguisher may be enough to lower your insurance costs. It can put out a small fire or suppress the flames while you escape. The National Fire Protection Association recommends having extinguishers at home that are accessible. It may cost more, but look for a rechargeable ABC-rated model with metal valves. That way, you won’t have to continually buy disposable fire extinguishers and you’ll be prepared for any type of fire.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: '<b>Potential savings</b>: As much as 5%' },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '10. Gated community discount' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Living within a gated community offers privacy and peace of mind. It also provides an extra layer of security that insurance providers will reward you for. You need a code to access homes within gated communities and the entrances are usually guarded with officers or cameras that monitor the neighborhood. This makes your home a lot less attractive to thieves. And compared to a homeowner living outside of a gated community, your chances of needing to file a criminal activity claim or request an insurance payout will be smaller.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: '<b>Potential savings</b>: Between 5% and 20%' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Still have questions about which discounts you’re eligible for with your home insurance provider?<br /> <b>Contact a</b> <a href='https://myhippo.com' target='_blank'>Hippo specialist</a>. <b>They’re here to help!</b>"
        },
        { element: 'p', className: 'bodyLeftColumnBigText', text: 'Save up to 25% now' }
    ];

    const BODY_TITLE_5 = [
        { element: 'p', className: 'bodyLeftColumnSmallTitle', text: 'Smart Coverage for Homeowners' },
        {
            element: 'p',
            className: 'bodyLeftColumnBigTitle',
            text: 'Top 5 Homeowners Insurance Claims (and How to Avoid Them)'
        }
    ];

    const BODY_LEFT_COLUMN_INTRO_5 = [
        { element: 'img', className: 'bodyLeftColumnPicture', attr: { src: 'taboola/resources/top_5_claims@2x.jpg' } },
        {
            element: 'p',
            className: 'bodyLeftColumnP',
            text:
                'Homeowners insure their properties against a number of potential threats: theft, floods, fires, earthquakes and everything in between. Catastrophic events, of course, are generally rare.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnP',
            text:
                'But that doesn’t mean you don’t need insurance. There’s no telling when you may need to file a claim and you don’t want to pay out-of-pocket for an unexpected accident.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnP',
            text:
                "<b>Water damage</b> <a href='https://myhippo.com/blog/the-importance-of-a-home-during-the-holiday-season/' target='_blank'>accounted for 35% of Hippo claims filed last year</a> <b>alone which</b> <a href='https://myhippo.com' target='_blank'>Hippo’s</a> <b>water backup, equipment breakdown and service line helped homeowners protect against when necessary</b>. Here are five of the most common reasons why homeowners file insurance claims and tips that will help you protect your home against these common homeowner pitfalls."
        }
    ];

    const BODY_LEFT_COLUMN_BODY_5 = [
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '1. Wind' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Wind is one of the most destructive forces on earth. Between 2009 and 2015, exterior wind damage claims accounted for 25% of all losses. Statistics show that 2017 was a record year for destruction resulting from natural disasters, such as hurricanes. Overall losses reached <a href='https://www.munichre.com/topics-online/en/2018/01/2017-year-in-figures?ref=social&amp;tid=Natcat&amp;inf=fig_0118_linkedin_ad1' target='_blank'>$330 billion</a>."
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: 'To avoid wind damage:' },
        { element: 'p', className: 'bodyLeftColumnSectionPWithPoint', text: 'Replace broken or cracked glass panes.' },
        { element: 'p', className: 'bodyLeftColumnSectionPWithPoint', text: 'Replace bent window frames and screens.' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text: 'Inspect your roof for loose or broken shingles or tiles. Repair all damaged areas.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Check window hinges, seals and locks. Ensure that seals are free of cracks and dirt and that windows can be shut and securely latched.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Install storm shutters or impact-resistant glass if you live in a region prone to tornadoes or hurricanes.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '2. Hail' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Even small pieces of hail can cause major damage, particularly when coupled with high winds. Each year, hail causes about $1 billion in damage to properties and crops, according to the National Oceanic Atmospheric Administration. Verisk Analytics issued a <a href='https://www.verisk.com/insurance/campaigns/hail-report/' target='_blank'>report</a> showing that insurers paid more than $54 billion to clients who filed nearly 9 million property hail claims between 2000 and 2013."
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: 'To avoid hail damage:' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Make sure your roof is in good shape and consider investing in impact-resistant roofing materials. Though the average roof lasts for at least 20 years, you should replace yours every seven to 10 years if severe hailstorms are common in your area.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Keep any equipment mounted on your roof (such as swamp cooler or satellite dish) covered to protect it from hail damage.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text: 'Consider investing in siding for your home made of a durable material such as fiber cement.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '3. Water ' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Water loss claims are common in the United States. Whether there’s a leaky faucet or a broken pipe, all homes are susceptible to water damage. Proper maintenance and early detection can be key in preventing water damage.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: 'To avoid water-related damage:' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Repair and replace shingles and tiles on your roof to avoid leaks and prevent moisture from creeping into your home during a storm. Make sure your flashing is also in good condition. It will help prevent water from penetrating the roof.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text: 'Check for leaks in your gutters and downspouts and clean gutters regularly.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Ensure that water drains away from your home’s foundation. Consider installing extension pipes to control the flow of water.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text: 'Trim low-hanging trees and branches that can break off during a storm and damage your home.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                "<p>Purchase water leak sensors or find an insurer, like <a href='https://myhippo.com/' target='_blank'>Hippo</a>, that will offer them for free.</p>"
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '4. Theft  ' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Each year, more than 2 million burglaries are reported in the U.S. Data from the FBI’s <a href='https://ucr.fbi.gov/crime-in-the-u.s/2016/crime-in-the-u.s.-2016/topic-pages/burglary' target='_blank'>Uniform Crime Reporting Program</a> reveals that the average dollar loss per burglary was $2,361 in 2016. Overall, property losses due to burglaries cost roughly $3.6 billion."
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: 'To avoid break-ins:' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text: 'Keep all doors and windows locked when you’re away from home.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text: 'Make sure your exterior lights are in working order and install motion-sensing lights.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Install indoor and outdoor security cameras that can alert you when a burglar is present and record any break-in attempts.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionPWithPoint', text: 'Store valuables in your garage or shed.' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Consider buying a home security monitoring system which not only monitors activity on your property but can save you money on your insurance premiums.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '5. Fire' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Data reveals that fires can cause extensive damage. Between 2011 and 2015, <a href='https://www.iii.org/fact-statistic/facts-statistics-homeowners-and-renters-insurance' target='_blank'>average claims for losses due to fire or lightning came to $43,983</a>.Taking certain safety tips into consideration may be necessary to prevent house fires."
        },
        { element: 'p', className: 'bodyLeftColumnSectionP', text: 'To avoid a house fire:' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Ensure that the electrical wiring in your home is up to code. Have your electrical system checked by a licensed electrician at least once a year.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text: 'Discuss fire safety with family members and minimize the use of candles around the home.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Install smoke detectors, a fire alarm system and a sprinkler system. These investments can reduce your homeowners insurance premiums.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                "  <p><a href='http://www.csia.org/firewood.html' target='_blank'>Inspect your chimney and have it</a> cleaned annually (especially if you have a wood-burning fireplace) to prevent the accumulation of creosote that can cause chimney fires.</p>"
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'After burning a fire, place the ashes in a metal container that you store outside of your home. This will minimize the odds of a stray spark starting a fire.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionPWithPoint',
            text:
                'Remove clutter from the area surrounding your stove and oven. Flammable materials could catch fire when you’re cooking or baking.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'It’s important to do whatever you can to protect your home from being damaged, and some of your efforts may save you money on insurance. '
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Take the necessary precautions to safeguard your home. If your home is damaged, don’t be afraid to use your homeowners insurance policy to cover the cost of repairs.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "Still have questions about safeguarding your home? <b>Speak with a</b> <a href='https://myhippo.com/' target='_blank'>Hippo</a> <b>specialist</b>."
        },
        { element: 'p', className: 'bodyLeftColumnBigText', text: 'Save up to 25% now' }
    ];

    const BODY_TITLE_6 = [
        { element: 'p', className: 'bodyLeftColumnSmallTitle', text: 'Smart Coverage for Homeowners' },
        { element: 'p', className: 'bodyLeftColumnBigTitle', text: 'The 11 Craziest Claims Homeowner Have Filed' }
    ];

    const BODY_LEFT_COLUMN_INTRO_6 = [
        { element: 'img', className: 'bodyLeftColumnPicture', attr: { src: 'taboola/resources/Hippo_Freak@2x.jpg' } },
        {
            element: 'p',
            className: 'bodyLeftColumnP',
            text:
                "Homeowners insurance is designed protect you when unexpected costs arise. But who foots the bill when something truly unexpected happens, like a freak accident you wouldn’t expect your insurance plan to cover? Luckily for some of these homeowners, they had insurance to cover these bizarre claims. Hippo insurance offers more coverage for unforeseen circumstances, like appliance breakdown and service line breaks than competitors and <a href='https://myhippo.com/' target='_blank'>saves customers up to 25%</a> off their monthly premiums."
        },
        {
            element: 'p',
            className: 'bodyLeftColumnP',
            text:
                'We asked experienced insurance professionals to share some of the craziest claims they’ve come across. You’ll never believe what they told us.'
        }
    ];

    const BODY_LEFT_COLUMN_BODY_6 = [
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '1. Too hot tub' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Imagine climbing into a hot tub full of 150-degree water. You feel a lot of pain and have to rush to the hospital because you have third-degree burns. That’s exactly what happened when one policyholder’s hot tub malfunctioned.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'If you own a home, keep in mind that you’re responsible for the maintenance and upkeep of everything on your property. That rule applies to everything from hot tubs to trampolines.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '2. Giant flying frisbees' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "When a big gust of wind whips through a neighborhood, trampolines can turn into giant flying frisbees. States like Georgia, <a href='https://myhippo.com/blog/united-states-dangerous-places-live/' target='_blank'>Texas</a> and parts of the Midwest are frequently battered by winds  reaching speeds of 50 miles per hour or more. On several occasions, a trampoline has flown into a neighbor’s home and caused extensive damage."
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '3. The chronicles of doors to nowhere' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'A closet door that leads to a magical land sounds great. But you should warn your guests if you have what insurers refer to as “doors to nowhere.” It’s not uncommon to hear about a visitor exiting a door and ending up with a broken leg.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '4. Over par' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'A round of golf in the backyard may sound great, but make sure you watch your drives. Errant shots can shatter windows and solar panels. Though the damage may be covered by your homeowners insurance policy, it may drive your premiums — and your golf score — way up.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '5. Wrong turn' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Corner lot homes often get unwanted visitors. And some may arrive by driving their car into your living room. The driver’s insurance policy should cover most of the damage. But if there’s a maximum coverage limit, you’ll need to ask your homeowners insurance company to chip in. If you live in a dangerous spot, consider installing a barricade in front of your house.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '6. DIY disaster' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'A homeowner who invited a friend to a barbecue ended up with a massive insurance claim. The deck he had just built wasn’t up to code and it collapsed under the weight of the party guests. The friend broke his wrist and suffered permanent nerve damage from the incident. He couldn’t keep working his high-paying job and ultimately sued for negligence. It’s safe to say they aren’t friends anymore.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionHeader',
            text: '7. When lightning struck the same place thrice'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'They say lightning won’t strike the same place twice, but one homeowner found out that’s simply not true. A big, beautiful willow in the backyard was struck three different times. On two of those occasions, branches fell and crushed someone’s car. The last time the tree collapsed, it took the neighborhood’s power lines with it.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '8. Firefighter fail' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'One home insurer paid a claim for a firefighter who burned his own home down. When a fire ignited in the kitchen, he panicked. Because he ran out of the front door instead of the side door, the flames spread quickly. Let’s just say he was pretty embarrassed when the fire trucks arrived.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '9. Review ruination' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Be careful when you write reviews online. What you say could be used against you. One home insurer got a phone call from a policyholder who was sued after he trashed a restaurant on Yelp. The restaurant claimed that the review was libelous and hurting their business.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '10. Sleepover suit' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'We know at least one policyholder who regrets letting their daughter have sleepovers. When the slumber party guests were supposed to be sleeping, one young girl decided to get a snack from the kitchen cabinet. She climbed up on the counter and got what she wanted, but got hurt on her way down. The damage was permanent and the homeowners incurred her hospital costs and a lawsuit.'
        },
        { element: 'p', className: 'bodyLeftColumnSectionHeader', text: '11. Costumed catastrophe' },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                'Homeowners love displaying decorations on their lawns during the holidays. And on Halloween, it’s normal for kids in a neighborhood to run from one house to another, on the lookout for candy. Sometimes, trick-or-treaters trip over cords tied to inflatable decorations and smash their faces. When that happens, the homeowner is usually held liable.'
        },
        {
            element: 'p',
            className: 'bodyLeftColumnSectionP',
            text:
                "To ensure you’re covered for whatever surprises come up, <a href='https://myhippo.com' target='_blank'>call a Hippo specialist today</a> or get a quote in 60 seconds at <a href='https://myhippo.com' target='_blank'>Hippo</a>."
        },
        { element: 'p', className: 'bodyLeftColumnBigText', text: 'Save up to 25% now' }
    ];

    const DATA = [
        {
            title: BODY_TITLE,
            leftColumn: {
                intro: BODY_LEFT_COLUMN_INTRO,
                body: BODY_LEFT_COLUMN_BODY
            },
            leftColumnFooter: {
                left: BODY_LEFT_COLUMN_LEFT_FOOTER,
                right: BODY_LEFT_COLUMN_RIGHT_FOOTER
            },
            rightColumn: BODY_RIGHT_COLUMN
        },
        {
            title: BODY_TITLE_2,
            leftColumn: {
                intro: BODY_LEFT_COLUMN_INTRO_2,
                body: BODY_LEFT_COLUMN_BODY_2
            },
            leftColumnFooter: {
                left: BODY_LEFT_COLUMN_LEFT_FOOTER,
                right: BODY_LEFT_COLUMN_RIGHT_FOOTER
            },
            rightColumn: BODY_RIGHT_COLUMN
        },
        {
            title: BODY_TITLE_3,
            leftColumn: {
                intro: BODY_LEFT_COLUMN_INTRO_3,
                body: BODY_LEFT_COLUMN_BODY_3
            },
            leftColumnFooter: {
                left: BODY_LEFT_COLUMN_LEFT_FOOTER,
                right: BODY_LEFT_COLUMN_RIGHT_FOOTER
            },
            rightColumn: BODY_RIGHT_COLUMN
        },
        {
            title: BODY_TITLE_4,
            leftColumn: {
                intro: BODY_LEFT_COLUMN_INTRO_4,
                body: BODY_LEFT_COLUMN_BODY_4
            },
            leftColumnFooter: {
                left: BODY_LEFT_COLUMN_LEFT_FOOTER,
                right: BODY_LEFT_COLUMN_RIGHT_FOOTER
            },
            rightColumn: BODY_RIGHT_COLUMN
        },
        {
            title: BODY_TITLE_5,
            leftColumn: {
                intro: BODY_LEFT_COLUMN_INTRO_5,
                body: BODY_LEFT_COLUMN_BODY_5
            },
            leftColumnFooter: {
                left: BODY_LEFT_COLUMN_LEFT_FOOTER,
                right: BODY_LEFT_COLUMN_RIGHT_FOOTER
            },
            rightColumn: BODY_RIGHT_COLUMN
        },
        {
            title: BODY_TITLE_6,
            leftColumn: {
                intro: BODY_LEFT_COLUMN_INTRO_6,
                body: BODY_LEFT_COLUMN_BODY_6
            },
            leftColumnFooter: {
                left: BODY_LEFT_COLUMN_LEFT_FOOTER,
                right: BODY_LEFT_COLUMN_RIGHT_FOOTER
            },
            rightColumn: BODY_RIGHT_COLUMN
        }
    ];

    this.getBodyData = function () {
        return DATA[index];
    };
}
